import { fromJS } from 'immutable';

import { ApiUrl4,UserToken,SenderId} from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (paramBody, file,senderid) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });
    const Authorization = UserToken;    
    const url = ApiUrl4 + 'config-waprofile-set';
    
    var sender = senderid
    // if(sender == null || sender == "" || sender == undefined){
    //     sender = SenderId
    // }
    
    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
            'senderid':sender
        },
        body : JSON.stringify(paramBody)
    };

    const response = await doFetch(url,argument);

    
    // const data = new FormData();
    // data.append('file', file );
    // console.log(file);
    // const url2 = ApiUrl2 + 'config-waprofilepicture-set';
    // const argument2 = {  
    //     method: 'POST',
    //     headers : {
    //         'Content-Type':'image/png',
    //         'Authorization': Authorization,
    //     },
    //     body : file
    // };  
    // const response2 = await doFetch(url2,argument2);   

    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : true });

    return response;
};